import { TranslationKey } from "@/types/translations";

export const NAV_KEYS = {
  HOME: "nav.home",
  PROPERTIES: "nav.properties",
  BLOG: "nav.blog",
  ABOUT: "nav.about",
  CONTACT: "nav.contact",
  LOGIN: "nav.login",
} as const satisfies Record<string, TranslationKey>;

export const HOME_KEYS = {
  HERO: {
    TITLE: "home.hero.title",
    HIGHLIGHT: "home.hero.highlight",
    SUBTITLE: "home.hero.subtitle",
    SEARCH_FORM_TITLE: "home.hero.search_form_title",
    CHECKIN: "home.hero.checkin",
    CHECKOUT: "home.hero.checkout",
    GUESTS: "home.hero.guests",
    BULLET_ONE: "home.hero.bullet_one",
    BULLET_TWO: "home.hero.bullet_two",
    BULLET_THREE: "home.hero.bullet_three",
    AVERAGE_RATING: "home.hero.average_rating",
    REVIEWS_COUNT: "home.hero.reviews_count",
  },
} as const satisfies Record<
  string,
  Record<string, TranslationKey> | TranslationKey
>;

export const PROPERTIES_KEYS = {
  TITLE: "properties.title",
  SUBTITLE: "properties.subtitle",
} as const satisfies Record<string, TranslationKey>;

export const STATS_KEYS = {
  BOOKINGS: "stats.bookings",
  HAPPY_GUESTS: "stats.happy_guests",
  AVERAGE_SCORE: "stats.average_score",
  SUPPORT: "stats.support",
} as const satisfies Record<string, TranslationKey>;

export const FEATURED_KEYS = {
  TITLE: "featured.title",
  SUBTITLE: "featured.subtitle",
} as const satisfies Record<string, TranslationKey>;

export const HOW_IT_WORKS_KEYS = {
  TITLE: "how_it_works.title",
  SUBTITLE: "how_it_works.subtitle",
  SEARCH: {
    TITLE: "how_it_works.search.title",
    DESCRIPTION: "how_it_works.search.description",
  },
  BOOK: {
    TITLE: "how_it_works.book.title",
    DESCRIPTION: "how_it_works.book.description",
  },
  ENJOY: {
    TITLE: "how_it_works.enjoy.title",
    DESCRIPTION: "how_it_works.enjoy.description",
  },
} as const satisfies Record<
  string,
  Record<string, TranslationKey> | TranslationKey
>;

export const REVIEWS_KEYS = {
  TITLE: "reviews.title",
  SUBTITLE: "reviews.subtitle",
  REVIEW_ONE_COMMENT: "reviews.review_one_comment",
  REVIEW_ONE_LOCATION: "reviews.review_one_location",
  REVIEW_TWO_COMMENT: "reviews.review_two_comment",
  REVIEW_TWO_LOCATION: "reviews.review_two_location",
  REVIEW_THREE_COMMENT: "reviews.review_three_comment",
  REVIEW_THREE_LOCATION: "reviews.review_three_location",
} as const satisfies Record<string, TranslationKey>;

export const FAQ_KEYS = {
  TITLE: "faq.title",
  SUBTITLE: "faq.subtitle",
  QUESTION_ONE: "faq.question_one",
  ANSWER_ONE: "faq.answer_one",
  QUESTION_TWO: "faq.question_two",
  ANSWER_TWO: "faq.answer_two",
  QUESTION_THREE: "faq.question_three",
  ANSWER_THREE: "faq.answer_three",
  QUESTION_FOUR: "faq.question_four",
  ANSWER_FOUR: "faq.answer_four",
  QUESTION_FIVE: "faq.question_five",
  ANSWER_FIVE: "faq.answer_five",
  QUESTION_SIX: "faq.question_six",
  ANSWER_SIX: "faq.answer_six",
  QUESTION_SEVEN: "faq.question_seven",
  ANSWER_SEVEN: "faq.answer_seven",
} as const satisfies Record<string, TranslationKey>;

export const FOOTER_KEYS = {
  DESCRIPTION: "footer.description",
  LINKS: "footer.links",
  CONTACT: "footer.contact",
  ESTANCIA_CORTA: "footer.estancia_corta",
  MANAGEMENT: "footer.management",
  PUBLISH: "footer.publish",
  RIGHTS: "footer.rights",
  PRIVACY_POLICY: "footer.privacy_policy",
} as const satisfies Record<string, TranslationKey>;

export const SEARCH_KEYS = {
  GUESTS: "search.guests",
  CHECKIN: "search.checkin",
  CHECKOUT: "search.checkout",
  BUTTON: "search.button",
} as const satisfies Record<string, TranslationKey>;

export const ABOUT_KEYS = {
  HERO: {
    TITLE: "about.hero.title",
    DESCRIPTION_FIRST: "about.hero.description.first",
    DESCRIPTION_SECOND: "about.hero.description.second",
  },
  STATS: {
    BOOKINGS: "about.stats.bookings",
    GUESTS: "about.stats.guests",
    RATING: "about.stats.rating",
  },
  MISSION: {
    TITLE: "about.mission.title",
    DESCRIPTION: "about.mission.description",
  },
  VALUES: {
    TITLE: "about.values.title",
    EXCELLENCE: {
      TITLE: "about.values.excellence.title",
      DESCRIPTION: "about.values.excellence.description",
    },
    HOSPITALITY: {
      TITLE: "about.values.hospitality.title",
      DESCRIPTION: "about.values.hospitality.description",
    },
    SUSTAINABILITY: {
      TITLE: "about.values.sustainability.title",
      DESCRIPTION: "about.values.sustainability.description",
    },
  },
  PROPERTY_OWNERS: {
    TITLE: "about.property_owners.title",
    SUBTITLE: "about.property_owners.subtitle",
    MANAGEMENT: {
      TITLE: "about.property_owners.management.title",
      DESCRIPTION: "about.property_owners.management.description",
    },
    MARKETING: {
      TITLE: "about.property_owners.marketing.title",
      DESCRIPTION: "about.property_owners.marketing.description",
    },
    SUPPORT: {
      TITLE: "about.property_owners.support.title",
      DESCRIPTION: "about.property_owners.support.description",
    },
    CTA: "about.property_owners.cta",
  },
} as const satisfies Record<
  string,
  | Record<string, TranslationKey | Record<string, TranslationKey>>
  | TranslationKey
>;
